// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cont-height{
    height: 715px;
}

@media screen and (min-height: 715px) {
    .cont-height{
        height: 100vh;
    }
}

@media screen and (max-width: 999px) {
    .cont-height{
        height: auto;
    }
}`, "",{"version":3,"sources":["webpack://./src/template/auth/Layout.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ","sourcesContent":[".cont-height{\n    height: 715px;\n}\n\n@media screen and (min-height: 715px) {\n    .cont-height{\n        height: 100vh;\n    }\n}\n\n@media screen and (max-width: 999px) {\n    .cont-height{\n        height: auto;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
